export const QUICK_LINKS_LIMIT = 32;
/**
 * We omit county and franchise values for fetching quicks links because the default links are the ones
 * which get the most search volume. We therefore want to make these easily found.
 *
 * The county links in a lot of counties are thin, with only a couple of franchises.
 */
export const QUICK_LINKS_COUNTY_VALUE = null;
export const QUICK_LINKS_FRANCHISE_VALUE = null;
